import { useEffect, useMemo } from 'react';
import { useQuery } from 'react-query';

import { getDevices } from '@/core/hostmanagement/open-amt/open-amt.service';
import { EnvironmentId } from '@/core/environments/types';
import PortainerError from '@/core/error';
import * as notifications from '@/core/services/notifications';

export function useAMTDevices(environmentId: EnvironmentId) {
  const { isLoading, data, isError, error } = useQuery(
    ['amt_devices', environmentId],
    () => getDevices(environmentId)
  );

  useEffect(() => {
    if (isError) {
      notifications.error(
        'Failure',
        error as Error,
        'Не удалось получить список устройств AMT'
      );
    }
  }, [isError, error]);

  const devices = useMemo(() => data || [], [data]);

  return {
    isLoading,
    devices,
    error: isError ? (error as PortainerError) : undefined,
  };
}
